import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { useSettingsStore } from '@/store/modules/settings';
import { useFullscreen } from '@vueuse/core'; 
import { defineComponent, ref, watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventListener } from '@vueuse/core';
// 添加这行
const imports = require.context('./', true, /\.vue$/);
const Components = {};
imports.keys().filter(key => key !== './index.vue').forEach(key => {
  Components[key.replace(/(\/|\.|index.vue)/g, '')] = imports(key).default;
});
export default defineComponent({
  name: 'Layouts',
  components: Components,
  setup() {
    const settingsStore = useSettingsStore();
    const {
      device,
      collapse,
      theme
    } = storeToRefs(settingsStore);
    const {
      toggleDevice,
      foldSideBar,
      openSideBar,
      updateTheme
    } = settingsStore;
    const mobile = ref(false);
    let oldLayout = theme.value.layout;
    const {
      isFullscreen
    } = useFullscreen();
    const resizeBody = () => {
      mobile.value = document.body.getBoundingClientRect().width - 1 < 480;
    };
    watch(mobile, val => {
      if (val) {
        oldLayout = theme.value.layout;
        foldSideBar();
        // 手机端切为纵向布局：菜单折叠成抽屉，展开时带遮罩（vertical 布局自带移动端处理）
        theme.value.layout = 'vertical';
      } else {
        openSideBar();
        theme.value.layout = oldLayout;
      }
      toggleDevice(val ? 'mobile' : 'desktop');
    });
    resizeBody();
    updateTheme();
    const cleanup = useEventListener('resize', () => {
      resizeBody();
    });
    onUnmounted(() => {
      // if (mobile) theme.value.layout = oldLayout
      cleanup();
    });
    return {
      theme,
      device,
      mobile,
      collapse,
      foldSideBar,
      openSideBar,
      toggleDevice,
      isFullscreen
    };
  }
});